module.exports = __webpack_public_path__ + "static/media/home.62423de9.svg";